import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  connectSiteState,
  editContentNumState,
  isDeleteLoadingState,
  isDetailState,
  isEditState,
  isThroughMainState,
  popState,
  userInfoState,
  writingTypeState
} from "../../../../atoms/atom";
import {
  loginKey,
  redirectURL,
  msgRedirectURL
} from "../../../../utils/CommonFunc";
import {
  NAVER_SIGN_IN_URL,
  SIGN_IN_URL
} from "../../../../utils/config/Config";
import { DeleteApi } from "../../Page/pageRight/PostContent/api";
import "./IsMyArticle.scoped.scss";
import { isLauncherState, loginState } from "../../../../atoms/userInfoAtom";

interface IProps {
  user_id: string;
  idx: number;
  nickname?: string;
}

function IsMyArticle(props: IProps) {
  const { t } = useTranslation();
  const { user_id, idx, nickname } = props;
  const { service_code, title } = useParams();
  const isLogin = useRecoilValue(loginState);
  const userInfo = useRecoilValue(userInfoState);
  const isDetail = useRecoilValue(isDetailState);
  const setPopOpen = useSetRecoilState(popState);
  const setWritingType = useSetRecoilState(writingTypeState);
  const setIsEdit = useSetRecoilState(isEditState);
  const setEditContentNum = useSetRecoilState(editContentNumState);
  const setIsDeleteLoading = useSetRecoilState(isDeleteLoadingState);
  const [editingToggle, setEditingToggle] = useState<any>({});
  const [isMyArticle, setIsMyArticle] = useState(false);
  const navigate = useNavigate();
  const isThroughMain = useRecoilValue(isThroughMainState);
  const connectSite = useRecoilValue(connectSiteState);
  const isLauncher = useRecoilValue(isLauncherState);

  const handleArticleEditor = (writerUser: string, idx: number) => {
    setEditingToggle({
      [idx]: !editingToggle[idx]
    });

    if (isLogin === true) {
      // 로그인 + 내글 : 수정, 삭제만
      if (
        writerUser.toLocaleLowerCase() === userInfo.Userid.toLocaleLowerCase()
      ) {
        setIsMyArticle(true);
        // 로그인 + 남의글 : 신고만
      } else {
        setIsMyArticle(false);
      }
      // 로그인 안함
    } else {
      //로그인 후 이용하실 수 있습니다.
      setIsMyArticle(false);
      if (isLauncher) {
        window.app.vfunRequestLogin();
      } else {
        msgRedirectURL(
          t(loginKey),
          connectSite === "vfun"
            ? SIGN_IN_URL(service_code || "vfun")
            : NAVER_SIGN_IN_URL + service_code,
          "_self"
        );
      }
    }
  };

  // 추후 삭제될 코드
  const compareUserId = (writerUser: string) => {
    if (
      writerUser.toLocaleLowerCase() === userInfo.Userid.toLocaleLowerCase()
    ) {
      return true;
    } else {
      return false;
    }
  };

  const useDeleteMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(DeleteApi, {
      onSuccess: (api) => {
        queryClient.invalidateQueries(["page_board_list"]);
        setIsDeleteLoading(false);
      },
      onError: (error: any) => {
        alert(t(error.response.data.message));
        setIsDeleteLoading(false);
      }
    });
  };

  const { mutate: deleteMutate } = useDeleteMutation();

  const deleteBoard = (idx: number) => {
    if (window.confirm(t("are_you_sure_you_want_to_delete_the_post"))) {
      const props = { service_code, title, idx, userInfo };
      deleteMutate(props);
      setIsDeleteLoading(true);
      setEditingToggle({});

      // 1. 리스트일 때 삭제 : isThroughMain === true && isDetail === false => url 이동 없음
      // 2. 리스트를 통한 디테일에서 삭제 : isThroughMain === true && isDetail === true => 리스트로 돌아가야 함 , navigate(-1)
      // 3. 복사된 디테일에서 삭제 : isThroughMain === false && isDetail === true => redirect 필요

      if (isDetail === true) {
        // 2번과 3번
        if (isThroughMain) {
          // 2번
          navigate(-1);
        } else {
          // 3번
          redirectURL(
            `${window.location.origin}/page/${service_code}`,
            "_self",
            isLauncher
          );
        }
      } else {
        // 1번
      }
    } else {
      return false;
    }
  };

  const editBoard = (idx: number) => {
    setIsEdit(true);
    setWritingType("content");
    setPopOpen(true);
    setEditContentNum(idx);
  };

  return (
    <div className="info-writing f-right" id="IsMyArticle">
      <span className="nickname clearfix">
        {nickname === "" || nickname === null ? user_id : nickname}
        {/* 신고 기능 준비되면 체크 */}
        {compareUserId(user_id) ? (
          <Link
            to="#"
            className="btns icon-dots"
            onClick={(e) => handleArticleEditor(user_id, idx)}
          />
        ) : null}
      </span>
      {editingToggle[idx] ? (
        <ul className="btns editing">
          {isMyArticle ? (
            <>
              <li className="edit">
                <Link to="#" onClick={() => editBoard(idx)}>
                  <span className="icon edit" />
                  {t("edit")}
                </Link>
              </li>
              <li className="delete">
                <Link to="#" onClick={() => deleteBoard(idx)}>
                  <span className="icon delete" />
                  {t("delete")}
                </Link>
              </li>
            </>
          ) : // <li className="report">
          //   <Link to="#">
          //     <span className="icon warning" />
          //     {t("report")}
          //   </Link>
          // </li>
          null}
        </ul>
      ) : null}
    </div>
  );
}

export default IsMyArticle;
